import { render } from "./statement.vue?vue&type=template&id=2a1724e6"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"

import "./statement.vue?vue&type=style&index=0&id=2a1724e6&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__